
import React, { useEffect, useState } from 'react'

import { firestore } from '../../../firebase'

function RemoveImageAlbum({albumId}) {

    const [images, setImages] = useState([])
    useEffect(() => {

        try {
            const imagesAlbumRef = firestore.collection("albums").doc(albumId).collection("images");
            imagesAlbumRef.onSnapshot(({docs}) => {
                const images = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                const filteredImages = images.map(image => {
                    return image.imageUrl;
                })
                setImages(images)
            })
        } catch (error) {
            console.log(error)
        }

    }, [albumId])

    async function removeHandler(e, imageId) {

        e.preventDefault();
        try {
            const imageRef = firestore.collection("albums").doc(albumId).collection("images").doc(imageId);
            imageRef.delete();
        } catch (error) {
            console.log(error)
        }

    }

    return (
        <div className="container">
            <div className="row">
                {images?.map((image, index) => {
                    return (
                        <div key={index} className="col-2">
                            <img src={image.imageUrl} alt={"album-media"} className="img-fluid player-image"/>
                            <button className="btn btn-danger" onClick={(e) => removeHandler(e, image.id)}>Fjern</button>
                        </div>
                    )
                })}
            </div>
        </div>

    )
}
export default RemoveImageAlbum